import MyService from '../../service';

const BrandApi = {
  getBrandByType: async (typeId) => {
    let result = [];

    await MyService.getRequestData(
      '/vehicles/brand/get-brand-vehicle-by-type',
      { vhc_type_id: typeId }
    )
      .then((res) => (result = res.data))
      .catch((err) => console.log(err));
    return result;
  },
};
export default BrandApi;
